import Decimal from 'decimal.js';
import React from 'react';
import { Numeric } from '@/lib/types/common';
import { Text, TextProps } from '@/lib/ui-kit/text';

type CentTextProps<C extends React.ElementType = 'span'> = TextProps<C> & {
  value: Numeric; // a number between 0 and 1
  decimals?: number; // how many decimals to display in the cents
};

export function CentText<C extends React.ElementType = 'span'>({
  value,
  decimals = 0,
  ...allTextProps
}: CentTextProps<C>) {
  const cent = new Decimal(value).mul(100).toDecimalPlaces(decimals).toFixed(decimals);

  return (
    <Text<C> {...(allTextProps as TextProps<C>)}>
      {cent}
      <span className="font-normal">¢</span>
    </Text>
  );
}
